import * as sup from "superstruct";

import { achievementItemIdentifierStruct } from "@/modules/achievements/api/achievementIdentifierStruct";
import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";
import { userRoles } from "@/modules/auth/api/resources/company/companyResourceStruct";

import { userIdentifierStruct } from "./userIdentifierStruct";

export const userResourceStruct = createResourceStruct({
  identifier: userIdentifierStruct,
  attributes: sup.object({
    firstName: sup.string(),
    lastName: sup.string(),
    email: sup.string(),
    birthDate: sup.nullable(sup.string()),
    employmentDate: sup.string(),
  }),
  meta: sup.object({
    role: userRoles,
  }),
  relationships: sup.object({
    userGroupAchievements: sup.object({
      data: sup.array(achievementItemIdentifierStruct),
    }),
  }),
});
